import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  VaRadio,
  VaRadioOption,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';

import { isLoggedIn } from '@department-of-veterans-affairs/platform-user/selectors';
import { apiRequest } from '@department-of-veterans-affairs/platform-utilities/api';
import { focusElement } from 'platform/utilities/ui';
import FormNavButtons from '~/platform/forms-system/src/js/components/FormNavButtons';

import Loader from '../components/Loader';
import CatAndTopicSummary from '../components/CatAndTopicSummary';
import { ServerErrorAlert } from '../config/helpers';
import { CHAPTER_1, URL, getApiUrl } from '../constants';

const SubTopicSelectPage = props => {
  const { onChange, loggedIn, goBack, formData, topicId, goForward } = props;

  const [apiData, setApiData] = useState([]);
  const [loading, isLoading] = useState(false);
  const [error, hasError] = useState(false);
  const [validationError, setValidationError] = useState(null);

  const handleContinue = () => {
    if (formData.selectSubtopic) {
      return goForward(formData);
    }

    setValidationError('Select a subtopic');
    return focusElement('va-radio-option input[type="radio"]');
  };

  const handleChange = event => {
    const selectedValue = event.detail.value;
    const selected = apiData.find(
      subtopic => subtopic.attributes.name === selectedValue,
    );
    onChange({
      ...formData,
      selectSubtopic: selectedValue,
      subtopicId: selected.id,
      subtopicAllowAttachments: selected.attributes.allowAttachments,
    });
  };

  const getApiData = url => {
    isLoading(true);
    return apiRequest(url)
      .then(res => {
        setApiData(res.data);
        isLoading(false);
      })
      .catch(() => {
        isLoading(false);
        hasError(true);
      });
  };

  useEffect(() => {
    getApiData(getApiUrl(URL.GET_SUBTOPICS, { PARENT_ID: `${topicId}` }));
    focusElement('h2');
  }, [loggedIn, topicId]);

  useEffect(() => {
    focusElement('h2');
  }, [loading]);

  // render loading indicator while we fetch
  if (loading) return <Loader />;

  return !error ? (
    <>
      {CatAndTopicSummary({
        category: formData.selectCategory,
        topic: formData.selectTopic,
      })}
      <form className="rjsf" data-dd-privacy="allow">
        <VaRadio
          onVaValueChange={handleChange}
          label={CHAPTER_1.PAGE_3.QUESTION_1}
          label-header-level={3}
          error={validationError}
          required
          name="root_selectSubtopic"
          uswds
        >
          {apiData.map(subTopic => (
            <VaRadioOption
              key={subTopic.id}
              name="root_selectSubtopic"
              id={subTopic.id}
              value={subTopic.attributes.name}
              label={subTopic.attributes.displayName}
              checked={subTopic.attributes.name === formData.selectSubtopic}
              uswds
            />
          ))}
        </VaRadio>

        <FormNavButtons goBack={goBack} goForward={handleContinue} />
      </form>
    </>
  ) : (
    <ServerErrorAlert />
  );
};

SubTopicSelectPage.propTypes = {
  formData: PropTypes.object,
  goBack: PropTypes.func,
  goForward: PropTypes.func,
  id: PropTypes.string,
  loggedIn: PropTypes.bool,
  topicId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    loggedIn: isLoggedIn(state),
    formData: state.form.data,
    topicId: state.form.data.topicId,
  };
}

export default connect(mapStateToProps)(SubTopicSelectPage);
